import $ from 'jquery';
import EdeeshopPopup from 'fg-frontend/plugins/edeeshop-popup/EdeeshopPopup';

// export to window
window.$ = $;
window.jQuery = $;

/**
 * Edeeshop Popup init
 */
window.edeeshopPopup = new EdeeshopPopup();



// WEBPACK FOOTER //
// ./config/module-publish/resources-3dliving/js/windowExports.js